var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgE8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ix:work-case-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12.27C4.55862 13.2654 7.25873 13.8493 10 14V16H14V14C16.7347 13.8287 19.4297 13.2594 22 12.31V20H2V12.27ZM15 3L16 3.99998V6H22V11.21C18.9338 12.3548 15.6927 12.9604 12.42 13H11.7C8.38339 12.9641 5.09935 12.3411 2 11.16V6H8V3.99998L8.99998 3H15ZM14 5.00002H10V6H14V5.00002Z",
    fill: "#15318D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE8);
export default __webpack_public_path__ + "static/media/e8.46b1edfbc6740db0e259b1e4f450c2fe.svg";
export { ForwardRef as ReactComponent };